import { Policy } from '@commandDrivenStateEngine/core/policies';
import { AccountState } from '../state';
import { AccountCommand } from '../commands';
import { ClientLibraryType } from '@bett3r-dev/teselly-client-library';
/**
 * Billing Entities Sync Policy
 *
 * Responsibilities:
 * - Subscribe to BillingEntities on init
 * - Dispatch upsert command when entities are inserted/updated
 * - Dispatch remove command when entities are deleted
 * - Cleanup subscription on unmount
 */
export const createBillingEntitiesSyncPolicy = (
  backend: ClientLibraryType
): Policy<AccountState, AccountCommand> => ({
  name: 'billing-entities-sync',

  init: ({ dispatch }) => {
    console.log( '[account] Initializing billing entities sync policy' );

    const close = backend.subscriptions.BillingEntities({}, ( change: any ) => {
      // Snapshot: full state initialization from subscription
      if ( change?.type === 'snapshot' ) {
        const entitiesMap: Record<string, any> = {};
        for ( const item of change.data.items ) {
          entitiesMap[item.id] = item;
        }
        dispatch(
          {
            type: 'account/billing/data/setAll',
            payload: { entities: entitiesMap }
          },
          { source: 'api' }
        );
        return;
      }

      if ( change?.data && [ 'insert', 'update' ].includes( change.type )) {
        dispatch(
          {
            type: 'account/billing/data/upsert',
            payload: { entity: change.data }
          },
          { source: 'api' }
        );
      } else if ( change?.previous && change?.type === 'delete' ) {
        dispatch(
          {
            type: 'account/billing/data/remove',
            payload: { entityId: change.previous.id }
          },
          { source: 'api' }
        );
      }
    });

    // Cleanup function
    return () => {
      console.log( '[account] Closing billing entities sync subscription' );
      if ( close?.close ) {
        close.close();
      }
    };
  }
});
